import firebase from "@/firebase";
import util from "@/util";
export default {
  namespaced: true,
  state: {
    tested: 50,
    goal: 50,
    oz: 0,
    vol: 0,
    type: "stabilizer",
    types: ["stabilizer", "liquid stabilizer"],
  },
  getters: {
    getCYA(state) {
      return state;
    },
  },
  mutations: {
    calcCYA(state, settings) {
      const gallons = util.getGallons(settings.volume, settings.unitType);
      if (state.tested < state.goal) {
        const temp = (state.goal - state.tested) * gallons;
        if (state.type === "liquid stabilizer") {
          state.vol = util.getVolume(temp / 2890, settings.unitType);
        } else {
          state.oz = util.getWeight(temp / 7489.51, settings.unitType);
          state.vol = util.getVolume(
            (temp / 7489.51) * 1.042,
            settings.unitType
          );
        }
      } else if (state.tested > state.goal) {
        const p = 100 - (state.goal / state.tested) * 100 + 0.5;
        state.percent = Math.floor(p);
      } else {
        state.oz = state.vol = 0;
      }
    },
    setCYA(state, cya) {
      if (!cya) {
        return;
      }
      state.tested = Number(cya.tested) || Number(state.tested);
      state.goal = Number(cya.goal) || Number(state.goal);
      state.oz = cya.oz || state.oz;
      state.vol = cya.vol || state.vol;
      state.type = cya.type || state.type;
    },
  },
  actions: {
    async initCYA(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("cya")
        .get();
      const cya = doc.data();
      state.commit("setCYA", cya);
    },
    async saveCYA(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("cya")
        .set({
          tested: data.tested,
          goal: data.goal,
          oz: data.oz,
          vol: data.vol,
          type: data.type,
        });
      state.commit("setCYA", data);
    },
  },
};
